var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"title_body"},[_c('span',{staticClass:"text_title text-h6"},[_vm._v(_vm._s(_vm.title))]),_c('span',{staticClass:"btn_close"},[_c('v-btn',{attrs:{"icon":"","dark":""},on:{"click":function($event){return _vm.$emit('close')}}},[_c('v-icon',{attrs:{"dark":""}},[_vm._v(" mdi-close ")])],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }